export default "__VITE_ASSET__DJTeOsvL__"